export default __webpack_public_path__ + "assets/Admin.29bc.svg";